import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiPost } from '@/lib/http/client';
import {
  portfolioMemberTeamsUrl,
  portfolioQueryKeys,
} from '@/lib/portfolio/api';

interface AssignTeamParams {
  userId: number;
  teamEntityId: string;
}

export function useAssignTeam(portfolioId: number, orgId: number) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ userId, teamEntityId }: AssignTeamParams) =>
      apiPost(portfolioMemberTeamsUrl(portfolioId, orgId, userId), {
        team_entity_id: teamEntityId,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: portfolioQueryKeys.orgMembers(portfolioId, orgId),
      });
    },
  });
}
